/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/prop-types */
import React from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import indicator from './classes/indicator';
import FromJoinRow from './fromJoinRow';
import GeoSpatialQueryBuilder from './geoSpatial/';

const FromClause = props => {
    const { query, updateQueryState, db, runPopupFix } = props;

    const handleDraggableDrop = result => {
        document.body.classList.remove('editorTab');
        document.body.classList.remove('queryBuilder');
        if (result.destination) {
            const startIndex =
        result.destination.index < result.source.index
            ? result.destination.index
            : result.source.index;

            const endIndex =
        result.destination.index < result.source.index
            ? result.source.index
            : result.destination.index;

            query.from.handleDraggableDrop(
                result.source.index,
                result.destination.index,
                startIndex,
                endIndex
            );

            updateQueryState();
            setTimeout(()=>{
                indicator.fromIndicator();
            });
        }
    };

    const handleDraggableStart = ()=>{
        document.body.classList.add('editorTab');
        document.body.classList.add('queryBuilder');
    };

    return (
        <DragDropContext onBeforeDragStart={handleDraggableStart} onDragEnd={handleDraggableDrop}>
            <Droppable droppableId="droppableFrom">
                {(provided, snapshot) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                        <div id="fromHolder" style={{ width: '98%', padding: '5px 10px', margin: '10px', marginTop: 0 }}>
                            {query.from.fromJoinRows.map((row, i) => {
                                return (
                                    <FromJoinRow
                                        key={`fromJoinRow-${i}`}
                                        query={query}
                                        updateQueryState={updateQueryState}
                                        runPopupFix={runPopupFix}
                                        rowIndex={i}
                                        row={row}
                                        db={db}
                                    />
                                );
                            })}
                        </div>
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
};

export default FromClause;
